import {
    IRecentMatchesFilters,
    IRecentMatchesState,
} from './RecentMatches-types';

const matchesState: IRecentMatchesState = {
    state: {
        page: 1,
        games: [],
        pages: [],
        filters: {
            base: false,
            nobility: false,
            nightfall: false,
            siege: false,
            mastery: false,
        },
    },
    mutations: {
        setRecentMatchesFilters(state, filters: IRecentMatchesFilters) {
            state.filters = filters;
        },
        setRecentMatchesGames(state, games: any[]) {
            state.games = games;
        },
        setRecentMatchesPages(state, pages: any[]) {
            state.pages = pages;
        },
        setRecentMatchesPage(state, page: number) {
            state.page = page;
        },
    },
    actions: {
        setRecentMatchesFilters({ commit }, filters: IRecentMatchesFilters) {
            commit('setRecentMatchesFilters', filters);
        },
        setRecentMatchesGames({ commit }, games: any[]) {
            commit('setRecentMatchesGames', games);
        },
        setRecentMatchesPages({ commit }, pages: number[]) {
            commit('setRecentMatchesPages', pages);
        },
        setRecentMatchesPage({ commit }, page: number) {
            commit('setRecentMatchesPage', page);
        },
    },
};

export default matchesState;
